<template>
  <div class="request-detail" dir="rtl">
    <div class="">
      <div
        ref="form"
        v-model="valid"
      >
        <div>

          <v-row class="relative">
            <v-col cols="12">
              <v-select
                :items="category_items"
                :label="$t('questionCategory')"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_category"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="relative">
            <v-col cols="12">
              <v-select
                :items="sub_category_items"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_sub_category"
              >
              </v-select>
            </v-col>

          </v-row>

          <v-row>

            <v-col cols="12">
              <v-textarea
                :label="$t('questionTitle')"
                v-model="question_title"
                outlined
                rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                :label="$t('QuestionSummary')"
                v-model="question_summary"
                outlined
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="blue-grey">
            <v-col cols="6">
              افزودن فایل
            </v-col>
            <v-col class="text-end" style="padding: 0px" cols="6">
              <v-btn
                color="primary"
                dark
                @click="select_file()"
                class="ma-2"
              >
                <v-icon
                  dark
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <input id="fileUpload" type="file" hidden v-on:change="input_file_changed">

            <v-row style="margin-bottom: 35px;">
              <v-col cols="4"
                     v-for="(item, i) in files"
                     :key="i"
              >
                <v-icon v-on:click="delete_file(i)" style="color: crimson">
                  mdi-close
                </v-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-img :src="item.file" width="100px" height="100px"/>

              </v-col>
            </v-row>

          </v-row>
        </div>
        <div>
          <v-row class="btn-end">

            <v-btn color="primary enter-btn" v-on:click="save()">
              {{$t('sendInformation')}}
            </v-btn>

          </v-row>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import {bus} from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        request_details: '',
        errors: [],
        phone_code_items: [],
        selected_phone_code: 1,
        other_number: '',

        category_items: [],
        selected_category: 0,
        sub_category_items: [],
        selected_sub_category: 0,

        device_status_items: [],
        selected_device_status: 0,
        province_items: [],
        selected_province: 0,

        city_items: [],
        selected_city: 0,

        send_from_country: false,


        question_title: '',
        question_summary: '',
        enable_send_from_country: false,
        customer_summary: '',
        valid: true,
        not_register: false,
        user_registered: false,

        files: [],
      }
    },
    watch: {
      selected_category: function () {
        this.get_sub_categories()
      }
    },
    mounted() {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
      // console.log("response", passing_data.ServiceOutBranchOnFinalize);

      this.enable_send_from_country = !passing_data.on_site_service
      if (passing_data.customer_summary != null) {
        this.customer_summary = passing_data.customer_summary
      }

      if (passing_data.other_phone_code != null) {
        this.selected_phone_code = passing_data.other_phone_code
      }
      if (passing_data.other_phone_no != null) {
        this.other_number = passing_data.other_phone_no
      }

      this.get_category()
    },
    methods: {
      select_file() {
        document.getElementById("fileUpload").click()
      },
      input_file_changed() {
        var self = this;

        var reader = new FileReader();
        var f = document.getElementById("fileUpload").files;

        reader.onloadend = function () {
          // console.log(reader.result);
          var obj = {file: reader.result, preview: reader.result, upload: 0}
          self.files.push(obj);
        }
        reader.readAsDataURL(f[0]);

      },
      delete_file(index) {


        this.files.splice(index, 1);


      },

      login() {
        var self = this

        const send_data = this.get_bind_data()
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkUserReq', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              bus.$emit('show_dialog', [self.$t('requestSubmitted'), response.data.msg + '\n' + self.$t('requestCodeQ') + response.data.ReqCode])
              self.$router.push({name: 'attachment', params: {rec_id: response.data.ReqId}})
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

      preRequestToRequest() {
        var self = this

        const send_data = this.get_bind_data()
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/PreRequestToRequest', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              var request_data = JSON.parse(localStorage.getItem('request_data'))

              if (request_data.ServiceOutBranchOnFinalize != null && request_data.ServiceOutBranchOnFinalize != '0') {
                self.submit_service_out_branch(response.data.ReqId, request_data.ServiceOutBranchOnFinalize, response)
              } else {
                bus.$emit('show_dialog', [self.$t('requestSubmitted'), response.data.msg + '\n' + self.$t('requestCodeQ') + response.data.ReqCode])

                self.$router.push({name: 'attachment', params: {rec_id: response.data.ReqId}})
              }
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      submit_service_out_branch(rec_id, status, res) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          ReqId: rec_id,
          Desc: '',
          StatusId: status,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangeRequestRefer', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              bus.$emit('show_dialog', [self.$t('requestSubmitted'), res.data.msg + '\n' + self.$t('requestCodeQ') + res.data.ReqCode])

              self.$router.push({name: 'attachment', params: {rec_id: response.data.ReqId}})
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_bind_data() {
        var request_id = 0

        var request_data = JSON.parse(localStorage.getItem('request_data'))
        if (request_data.PreRequestId != null) {
          request_id = request_data.PreRequestId
        }
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // var pre_defined_array = []
        // var pre_defined = JSON.parse(request_data.pre_defined)


        const send_data = {
          Id: 0, //
          ProductTypeId: request_data.cat_id, //
          CategoryId: request_data.group_id, //
          GroupId: request_data.sub_group_id, //
          SubGroupId: request_data.brand_id, //
          PhoneCode: this.selected_phone_code, //
          PhoneNo: this.other_number, //
          UserId: user_id, //
          ModelId: request_data.device_model_id, //
          ModelTitle: request_data.device_model, //
          Description: this.customer_summary, //
          RequestName: request_data.request_name + ' ' + request_data.device_model,
        }
        console.log('salam ' + JSON.stringify(send_data))
        return send_data
      },
      go_to_categories() {
        if (this.customer_summary == '') {
          bus.$emit('show_toast', [1500, this.$t('fillAllFields')])

          return false
        }

        var request_data = JSON.parse(localStorage.getItem('request_data'))
        if (request_data.stateId == null) {
          this.login()
        } else if (request_data.stateId == 'final_pre_request') {
          this.preRequestToRequest()
        }
      },

      get_category() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetQuestionMainCategories', send_data, {})
          .then(response => {
            response.data.mainCats.forEach(function (number) {
              var obj = {value: number.Id, label: number.MainCategoryTitle}
              self.category_items.push(obj)
            })
            self.selected_category = self.category_items[0].value;
          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_sub_categories() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          MainId: this.selected_category,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetQuestionCatsByMainId', send_data, {})
          .then(response => {
            self.city_items = []
            response.data.cats.forEach(function (number) {
              var obj = {value: number.Id, label: number.CategoryTitle}
              self.sub_category_items.push(obj)
            })
            self.selected_sub_category = self.sub_category_items[0].value

          }).catch(e => {
          this.errors.push(e)
        })
      },
      save() {
        if(this.selected_sub_category==0){
          bus.$emit('show_toast', [2000, this.$t('insertQuestionCategory')])
          return false;
        }
        if(this.question_title==0){
          bus.$emit('show_toast', [2000, this.$t('insertQuestionTitle')])
          return false;
        }
        if(this.question_title==0){
          bus.$emit('show_toast', [2000, this.$t('insertQuestionSummary')])
          return false;
        }
        if (this.files.length) {
          this.upload_image(0)

          for (var i = 0; i < this.files.length; i++) {
          }
        } else {
          this.send_question();
        }
      },
      upload_image(index) {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        var form_data = new FormData();
        form_data.append("UserId", user_id);
        form_data.append("ProcessId", this.$route.rec_id);
        form_data.append("Format", "png");
        form_data.append("ReqType", 3);
        form_data.append("DocType", 1);
        var file = this.dataURLtoFile(this.files[index].file, 'attach.png');
        form_data.append("Picture", file);

        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            // self.send_signature(response.data.ArchiveId,response.data.ImageName);
            if (response.data.error == 0) {
              self.files[index].upload = 1;
              self.files[index].ArchiveId = response.data.ArchiveId;
              self.files[index].ImageName = response.data.ImageName;
              var finish_all = true;
              self.files.forEach(function (number) {
                if (number.upload != 1) {
                  finish_all = false;
                }
              });
              console.log("all file checked is ",finish_all);
              if (finish_all) {
                self.send_question()
              }
            } else {
              self.files[index].upload = 2

            }
          }).catch(e => {
          this.errors.push(e);

        })

      },
      dataURLtoFile(dataurl, filename) {

        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type: mime});
      },

      send_question() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        var phone = localStorage.getItem("phone");
        // console.log();

        var attachment_array = [];
        console.log("send question caleed")

        self.files.forEach(function (number) {

          var pre_obj = {
            ArchiveId: number.ArchiveId,
            ImageName: number.ImageName,
            Summary: "",
          };
          attachment_array.push(pre_obj)
        });
        console.log("send question caleed")

        const send_data = {
          "Attachments": attachment_array,
          "UserId": user_id,
          "ProcessId": this.$route.params.rec_id,
          "CustomerPhone": phone,
          "Phone":phone,
          "QuestionBody":this.question_summary,
          "QuestionTitle":this.question_title,
          "QCategoryId":this.selected_sub_category,

        };



        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddQuestion', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              bus.$emit('show_toast', [5000, response.data.msg])

              self.$router.go(-1)
            } else {
              bus.$emit('show_toast', [1500, "خطا در ثبت تصاویر"])

            }
          }).catch(e => {
          this.errors.push(e);

        })

      }

    }
  }
</script>
